import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import SetupMeeting from './notar/SetUpMeeting'





/**
 * Renders the appropriate dashboard component based on the user type and signalr connection status.
 *
 * @return {JSX.Element} The rendered dashboard component.
 */

const SetupForDrn = () => {
    const signalrconnected = useSelector((state: any) => state.user.connected)
    const usertype = useSelector((state: any) => state.user.usertype)
    
    
   

    return (
        <>
         <SetupMeeting />
          
    </> 
    )

}

export default SetupForDrn;
